/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate, useSearchParams } from "react-router-dom";
import Logo from "../../components/app/Logo"
import CreditCardInfo from "./CreditCardInfo";
import useAuth from "../../hooks/auth";
import { addPaymentMethod, subscriptionUpgrade } from "./api";
import { useMemo } from "react";
import { loadStripe } from '@stripe/stripe-js';
import {
  Elements, useElements, useStripe,

} from '@stripe/react-stripe-js';
import { SubscriptionApi } from "../../api/client";
import { UserAuth } from "../../modules/auth/AuthState";
import { toast } from "react-toastify";

const AddPaymentMethod = () => {
  const [searchParams] = useSearchParams();

  const isFree = useMemo(() => {
    return searchParams.get('plan') === 'free'
  }, [searchParams])
  const navigate = useNavigate();
  const [{ auth }, { setAuth }] = useAuth();

  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (tokenId: string) => {
    if (!auth?.id) return null

    const res = await addPaymentMethod(auth.id, tokenId, 'card', true)
    await subscriptionUpgrade(
      auth.id,
      'b0da275520918e23dd615e2a747528f1',
      res.data?.payment_method?.id || '',
      'build'
    )
    return null
  }

  const onClick = async () => {
    if (!elements) return

    const token = await stripe?.createToken(elements.getElement('cardNumber')!);

    if (token?.token?.id) {
      if (!auth?.id) return

      const res = await addPaymentMethod(auth.id, token?.token?.id, 'card', true)
      await subscriptionUpgrade(
        auth.id,
        'b0da275520918e23dd615e2a747528f1',
        res.data?.payment_method?.id || '',
        'build'
      )
      toast.success('Subscription upgraded successfully', { autoClose: 3000 })
      navigate('/v2/explore')
    }
  }

  const onSkip = async () => {
    const client = SubscriptionApi()
    await client.freePlanChosenCreate({
      planChosen: true
    })
    setAuth((prev: UserAuth | null | undefined) => {
      if (prev) return {
        ...prev,
        subscription: {
          ...prev.subscription,
          planChosen: true
        }
      }
      return null
    })

    navigate('/v2/explore')
  }


  return <div className='min-h-[calc(100vh-380px)] pt-16'>
    <div className='max-w-[480px] mx-[auto]'>
      <div className='flex justify-center'>
        <Logo />
      </div>

      <div className='bg-[#fff] mt-8 pb-10'>
        <div className='bg-[#fff] px-8 py-4 flex justify-between items-center border-b'>
          <span className=' font-bold'>
            Add Payment Info
          </span>
        </div>


        <CreditCardInfo onSubmit={handleSubmit} />


        <div className="px-8 pb-2 flex justify-between mt-4">
          <button className="btn bg-[#fafafa] border-[#e2e2e3] text-[#333] w-[200px]" onClick={() => {

            navigate('/v2/onboarding/choose-plan')
          }}>
            Back
          </button>
          <button className="btn btn-primary bg-[#281AF0] w-[200px]" onClick={onClick}>
            Subscribe
          </button>
        </div>

        {
          isFree && <div className="mt-6 text-center text-[#263dff] cursor-pointer font-normal" onClick={() => {
            onSkip()
          }}>
            Skip
          </div>
        }
      </div>

    </div>
  </div>
}

const StripeWrapAddPaymentMethod = () => {
  const stripePromise = loadStripe('pk_test_51LpQfhFfZvE8Y7MuLM9Ez9wXVyi1j6ywQ7hewHDtkXc9hi1RFktnUMVnXGv2A7KDN4B98gwglFNgBQCYTL9UtWfu00NkLMAR9z');
  const options = {
    mode: 'payment',
    amount: 1099,
    currency: 'usd',
    // Fully customizable with appearance API.
    appearance: {
    },
  };

  return <Elements stripe={stripePromise} options={options as any}><AddPaymentMethod /> </Elements>
}

export default StripeWrapAddPaymentMethod;